import React from "react";
import { ArrowRight, Clock } from "lucide-react";

/**
 * OffersScreen — funding offers list mockup inside the phone.
 * All content is illustrative — no fabricated aggregate statistics.
 */
export const OffersScreen = () => {
  const offers = [
    {
      range: "$25K – $60K",
      term: "6–12 months",
      partnerType: "Working Capital",
      match: "Strong Match",
    },
    {
      range: "$45K – $120K",
      term: "12–18 months",
      partnerType: "Growth Line",
      match: "Excellent Match",
    },
    {
      range: "$15K – $40K",
      term: "3–9 months",
      partnerType: "Inventory Line",
      match: "Good Match",
    },
  ];

  return (
    <div
      className="relative flex h-full w-full flex-col overflow-hidden bg-gradient-to-b from-[#080808] to-[#050505] px-5 pb-5 pt-14"
      data-testid="app-screen-offers"
    >
      <div className="absolute left-0 right-0 top-3 flex items-center justify-between px-8 text-[10px] font-medium text-white/70">
        <span>9:41</span>
        <span>●●●</span>
      </div>

      <div className="pt-3">
        <span className="text-[10px] uppercase tracking-widest text-text-muted">
          Personalized
        </span>
        <h3 className="mt-1 font-display text-xl font-semibold leading-tight text-white">
          Funding Offers
        </h3>
        <p className="mt-1 text-[10px] text-text-muted">
          Matched to your ZenScore
        </p>
      </div>

      <div className="mt-4 flex flex-col gap-2.5">
        {offers.map((o, i) => (
          <div
            key={o.range}
            className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-3"
          >
            <div className="flex items-center justify-between">
              <span className="text-[9px] uppercase tracking-widest text-brand-emerald">
                {o.match}
              </span>
              <span className="inline-flex items-center gap-1 text-[9px] text-text-muted">
                <Clock className="h-2.5 w-2.5" />
                {o.term}
              </span>
            </div>
            <div className="mt-1.5 flex items-center justify-between">
              <div className="flex flex-col">
                <span className="font-display text-base font-semibold text-white tabular-nums">
                  {o.range}
                </span>
                <span className="text-[10px] text-text-secondary">
                  {o.partnerType}
                </span>
              </div>
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-brand-emerald text-black">
                <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.5} />
              </span>
            </div>
            {/* Fit bar */}
            <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-white/[0.05]">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${72 + i * 8}%`,
                  background:
                    "linear-gradient(90deg, #00C853 0%, #00E676 100%)",
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-auto flex items-center justify-around rounded-2xl border border-white/[0.06] bg-white/[0.02] px-2 py-2">
        {[
          { label: "Home", active: false },
          { label: "Score", active: false },
          { label: "Offers", active: true },
          { label: "Docs", active: false },
        ].map((tab) => (
          <div
            key={tab.label}
            className={
              tab.active
                ? "flex flex-col items-center gap-0.5 text-brand-emerald"
                : "flex flex-col items-center gap-0.5 text-text-muted"
            }
          >
            <span className="h-1.5 w-1.5 rounded-full bg-current" />
            <span className="text-[9px] font-medium">{tab.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OffersScreen;
